import React from 'react';
import PropTypes from 'prop-types';

import { useContext } from '@hooks';
import { mergeClasses } from '@utils';

import { InputContext } from './Input';

/**
 * Input.HelperMessage component that displays a helper message.
 * Must be a child of `Input`.
 *
 * @component Input.HelperMessage
 * @param {Object} props - The properties for the Input.HelperMessage component.
 * @param {string} props.children - The helper message to display.
 * @param {string} [props.className] - Optional additional CSS classes to apply to the helper message.
 * @returns {ReactElement} The rendered Input.HelperMessage component or `NULL` if input is invalid.
 */

export default function InputHelperMessage({
  children,
  className,
  ...restProps
}) {
  const { isValid } = useContext(
    InputContext,
    'Input.HelperMessage must be a child of Input.'
  );

  if (isValid === false) return null;

  return (
    <span
      className={mergeClasses(
        'block text-right text-xs font-semibold text-black',
        className
      )}
      {...restProps}
    >
      {children}
    </span>
  );
}

InputHelperMessage.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

InputHelperMessage.defaultProps = {
  className: ''
};
